import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Prerendered HTML carries JSON-LD hoisted into <head> for crawlers. React is
// about to render the same blocks again, so drop the static copies first —
// every structured-data block must appear exactly once per page.
if (document.documentElement.hasAttribute("data-prerendered")) {
  document.querySelectorAll('script[type="application/ld+json"][data-ssg-ld]').forEach((el) => el.remove());
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // HelmetProvider lives OUTSIDE <StrictMode> so its internal sink isn't
  // recreated by StrictMode's intentional double-invoke effects (a known
  // edge case with react-helmet-async v2 + synchronous route components).
  <HelmetProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </HelmetProvider>
);
